import { Link } from "react-router-dom";
import clsx from "clsx";
import { ADMIN_PATH } from "../path";
import { isAdmin } from "../utils";
import { RenderWhen } from "../components";
import SanitizeHTML from "./Sanitize";

type AdminBreadcrumbsProps = {
  rootLink?: string;
  rootText?: string;
  separator?: string;
  pageTitle: string;
  useRouter?: boolean;
  showRootForNonAdmin?: boolean;
  className?: string;
};

const AdminBreadcrumbs = ({
  rootLink = ADMIN_PATH.ADMIN_DASHBOARD,
  rootText = "Home",
  separator = "&rsaquo;",
  pageTitle,
  useRouter = false,
  showRootForNonAdmin = false,
  className
}: AdminBreadcrumbsProps) => {
  const isAdminUser = isAdmin();
  const rootLinkElement = useRouter ? (
    <Link to={rootLink}>{rootText}</Link>
  ) : (
    <a href={`/${rootLink}`}>{rootText}</a>
  );

  return (
    <div className={clsx("admin-breadcrumbs", className)}>
      <RenderWhen condition={isAdminUser || showRootForNonAdmin}>
        {rootLinkElement} <SanitizeHTML html={separator} inline />{" "}
      </RenderWhen>
      {pageTitle}
    </div>
  );
};

export default AdminBreadcrumbs;
